import { colors, Container } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import BulletinControl from './BulletinControl';
import HelperControl from './HelperControl';
import ProductControl from './ProductControl';
import ProductDefectControl from './ProductDefectControl';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(1)
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function Isler(props) {
  const classes = useStyles();
  const { t } = useTranslation('product_detail_control');
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page className={classes.root} title={TitleApp}>
      <Container>
        <Header />
      </Container>
      <Tabs
        value={value}
        aria-label="simple tabs example"
        textColor="secondary"
        scrollButtons="on"
        indicatorColor="primary"
        variant="scrollable"
        onChange={handleChange}
      >
        <Tab label={t('urun')} />
        <Tab label={t('Bulten')} />
        <Tab label={t('Kutuphane')} />
        <Tab label={t('Malzeme')} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <ProductControl />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <BulletinControl />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <HelperControl />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ProductDefectControl />
      </TabPanel>
    </Page>
  );
}

export default Isler;
